const isAdminSubdomain = typeof window !== 'undefined' && window.location.hostname.startsWith('admin.');

const ADMIN_PREFIX = isAdminSubdomain ? '' : '/admin';

function adminPath(path = '') {
  if (!path || path === '/') return ADMIN_PREFIX || '/';
  return `${ADMIN_PREFIX}${path.startsWith('/') ? path : '/' + path}`;
}

export { isAdminSubdomain, ADMIN_PREFIX, adminPath };
